import { createFeature, createReducer } from '@ngrx/store';

import { blueSageTerminalPickerReducers } from './bluesage-terminal-picker.reducer';
import { blueSageTerminalPickerInitialState } from './bluesage-terminal-picker.state';

export const blueSageTerminalPickerFeature = createFeature({
    name: 'blueSageTerminalPicker',
    reducer: createReducer(blueSageTerminalPickerInitialState, ...blueSageTerminalPickerReducers),
});
